export default "__VITE_ASSET__eaBvOPuQ__"